import { FixedEditorLayout } from "components/modules/Layout/FixedEditorLayout/FixedEditorLayout";
import { EditorNavbar } from "components/modules/Navigation/EditorNavbar/EditorNavbar";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAppSelector } from "store/store";
import { ImageCropperBottomMenu } from "./BottomMenu/ImageCropperBottomMenu";
import { ImageCropperCropSettings } from "./EditSettings/CropSettings/ImageCropperCropSettings";
import { CropPreview } from "./Preview/CropPreview";

export const Crop = () => {
    const fromEditor = useAppSelector((state) => state.crop.fromEditor);
    const router = useRouter();

    useEffect(() => {
        if (!fromEditor) {
            router.replace(`/crop-image`);
        }
    }, []);

    return (
        <FixedEditorLayout
            navbar={<EditorNavbar actionButton={null} url={"/crop-image/editor"} />}
            action={{
                desktop: null,
            }}
            bottomMenu={<ImageCropperBottomMenu />}
            controlBar={null}
            preview={<CropPreview />}
            leftBar={<ImageCropperCropSettings />}
        />
    );
};
